import state from './moduleDriversState'
import mutations from './moduleDriversMutations'
import actions from './moduleDriversActions'
import getters from './moduleDriversGetters'

export default {
  namespaced: true,
  state, 
  mutations,
  actions,
  getters
}